// extracted by mini-css-extract-plugin
export default {"root":"as_seen_in_root__-bXMd","suptitle":"as_seen_in_suptitle__uJNX3"};